/** CRM pipeline stages with default win probabilities (Saudi sales cycle). */
export const CRM_PIPELINE_STAGES = [
  { value: 'lead', labelKey: 'modules.crm.pipeline.stage_lead', labelAr: 'عميل محتمل', probability: 10 },
  { value: 'qualified', labelKey: 'modules.crm.pipeline.stage_qualified', labelAr: 'مؤهل', probability: 25 },
  { value: 'proposal', labelKey: 'modules.crm.pipeline.stage_proposal', labelAr: 'عرض سعر', probability: 50 },
  { value: 'negotiation', labelKey: 'modules.crm.pipeline.stage_negotiation', labelAr: 'تفاوض', probability: 75 },
  { value: 'closed_won', labelKey: 'modules.crm.pipeline.stage_won', labelAr: 'مغلق — فوز', probability: 100 },
  { value: 'closed_lost', labelKey: 'modules.crm.pipeline.stage_lost', labelAr: 'مغلق — خسارة', probability: 0 },
];

export function getCrmStageLabel(stage, t) {
  const found = CRM_PIPELINE_STAGES.find((s) => s.value === stage);
  if (!found) return stage || '—';
  if (t && found.labelKey) {
    const translated = t(found.labelKey);
    if (translated && translated !== found.labelKey) return translated;
  }
  return found.labelAr;
}

export function getCrmStageProbability(stage) {
  return CRM_PIPELINE_STAGES.find((s) => s.value === stage)?.probability ?? 0;
}

/** Campaign types for Saudi market. */
export const CRM_CAMPAIGN_TYPES = [
  { value: 'whatsapp', label: 'حملة واتساب' },
  { value: 'sms', label: 'حملة SMS' },
  { value: 'email', label: 'حملة بريد إلكتروني' },
  { value: 'social', label: 'حملة وسائل التواصل' },
  { value: 'multi_channel', label: 'حملة متعددة القنوات' },
  { value: 'event', label: 'فعالية / معرض' },
];

/** Customer segment types. */
export const CRM_SEGMENT_TYPES = [
  { value: 'demographic', label: 'ديموغرافي' },
  { value: 'geographic', label: 'جغرافي' },
  { value: 'behavioral', label: 'سلوكي' },
  { value: 'value', label: 'حسب القيمة' },
  { value: 'vip', label: 'عملاء VIP' },
];

/** Quote / proposal statuses. */
export const CRM_QUOTE_STATUSES = [
  { value: 'draft', label: 'مسودة' },
  { value: 'sent', label: 'مُرسل' },
  { value: 'accepted', label: 'مقبول' },
  { value: 'rejected', label: 'مرفوض' },
  { value: 'expired', label: 'منتهي الصلاحية' },
];
